import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

interface PremiumStatus {
  isPremium: boolean;
  subscriptionStatus: string;
  subscriptionEndDate: string | null;
}

export const usePremium = () => {
  const { user } = useAuth();
  const [premiumStatus, setPremiumStatus] = useState<PremiumStatus>({
    isPremium: false,
    subscriptionStatus: 'inactive',
    subscriptionEndDate: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setPremiumStatus({
        isPremium: false,
        subscriptionStatus: 'inactive',
        subscriptionEndDate: null,
      });
      setLoading(false);
      return;
    }

    const fetchPremiumStatus = async () => {
      try {
        const { data, error } = await supabase
          .from('premium_users')
          .select('subscription_status, subscription_end_date')
          .eq('user_id', user.id)
          .single();

        if (error && error.code !== 'PGRST116') {
          console.error('Error fetching premium status:', error);
          return;
        }

        if (data) {
          const isActive = data.subscription_status === 'active' && 
            (!data.subscription_end_date || new Date(data.subscription_end_date) > new Date());
          
          setPremiumStatus({
            isPremium: isActive,
            subscriptionStatus: data.subscription_status,
            subscriptionEndDate: data.subscription_end_date,
          });
        }
      } catch (error) {
        console.error('Error fetching premium status:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPremiumStatus();
  }, [user]);

  return {
    ...premiumStatus,
    loading,
  };
};